export default __webpack_public_path__ + "static/media/logo.d88adb95.svg";